<div class="process-container">
  <h1>Process: {{description}}</h1>

  <div class="progress-section" *ngIf="isProcessing">
    <mat-progress-bar mode="determinate" [value]="progress" color="accent"></mat-progress-bar>
    <div class="progress-info">
      <span>{{'PROCESS.progress' | translate }}: {{currentIndex}}/{{totalRecords}}</span>
    </div>
    <button class="btn-abort" mat-flat-button color="warn" (click)="abortProcess()" [disabled]="!isProcessing || isAborted">
      {{'PROCESS.abort' | translate }}
    </button>
  </div>

  <div class="table-section">
    <table mat-table [dataSource]="processItems" class="process-table">
      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{'PROCESS.id' | translate}}</th>
        <td mat-cell *matCellDef="let item">{{item.id}}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{'PROCESS.status' | translate}}</th>
        <td mat-cell *matCellDef="let item">
          <span [class]="'status-' + item.status">{{item.status}}</span>
        </td>
      </ng-container>

      <!-- Response Column -->
      <ng-container matColumnDef="response">
        <th mat-header-cell *matHeaderCellDef>{{'PROCESS.response' | translate}}</th>
        <td mat-cell *matCellDef="let item" class="response-cell">{{item.response}}</td>
      </ng-container>

      <!-- Error Column -->
      <ng-container matColumnDef="error">
        <th mat-header-cell *matHeaderCellDef>{{'PROCESS.error' | translate}}</th>
        <td mat-cell *matCellDef="let item" class="error-cell">{{item.error}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div class="completion-message" *ngIf="isComplete">
    <p>{{'PROCESS.process' | translate}}: {{description}} 
      <span class="status-badge" [class.status-aborted]="isAborted" [class.status-complete]="!isAborted">
        {{isAborted ? ('PROCESS.aborted' | translate) : ('PROCESS.complete' | translate)}}
      </span>
    </p>
    <p>{{'PROCESS.successful' | translate}}: {{successfulCount}}, {{'PROCESS.failed' | translate}}: {{failureCount}}</p>
  </div>
</div> 